<h2 mat-dialog-title>
  {{ translation.t('officerUpdateComplaints', 'updateComplaintTitle') }} <br>
  <small style="font-weight:10px; font-size: 14px; padding-left: 5px;">{{ translation.t('officerUpdateComplaints', 'reviewInstruction') }}</small>
  <button mat-icon-button (click)="onClose()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content mt-3">
  <form [formGroup]="complaintForm">
    <mat-label>{{ translation.t('officerUpdateComplaints', 'updateStatus') }}<span style="color: red;">*</span></mat-label>
    <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
      <mat-select formControlName="status" name="status" required>
        <mat-option value="RESOLVED" *ngIf="updatedata['status']=='PENDING'">{{ translation.t('officerUpdateComplaints', 'resolved') }}</mat-option>
        <mat-option value="CLOSED" *ngIf="updatedata['status']=='RESOLVED'">{{ translation.t('officerUpdateComplaints', 'closed') }}</mat-option>
      </mat-select>
    </mat-form-field>

    <br />

    <mat-label>{{ translation.t('officerUpdateComplaints', 'remarksActionTaken') }}<span style="color: red;">*</span></mat-label>
    <mat-form-field appearance="outline" class="full-width" style="width: 100%;">
      <textarea matInput rows="4" formControlName="remarks" name="remarks" required></textarea>
    </mat-form-field>

    <br />

    <mat-label>{{ translation.t('officerUpdateComplaints', 'uploadSupportingDoc') }}</mat-label>
    <!-- <mat-form-field appearance="outline" class="full-width" style="width: 100%;" (click)="fileInput.click()">
      <input matInput [value]="uploadedFileName" readonly />
      <button mat-icon-button matSuffix aria-label="Upload file">
        <mat-icon>upload</mat-icon>
      </button>
      <input type="file" #fileInput style="display: none" />
    </mat-form-field> -->
                  <input #resolvedDocInput type="file" formControlName="doc_name"  id="mapFileInput" accept="application/pdf" (change)="checkFile($event,'')" style="margin-top: 5px;"  #fileInputl name="invoiceFile"   class="upload-box form-control"  />
                <p (click)="view('')" class="text-right text-primary" style="text-decoration: underline; cursor: pointer;" *ngIf="selectedFileUrlObj['resolved']   || selectedFileUrlObj['closed'] ">{{ translation.t('officerUpdateComplaints', 'clickHereToView') }} </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button style="background-color: #226CE0; color: white;" (click)="submit()">{{ translation.t('officerUpdateComplaints', 'updateComplaintBtn') }}</button>
</mat-dialog-actions>